module.exports = __webpack_public_path__ + "static/assets/87c98d386b3f4423fc82ecec23ca4f16.png";